import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
var MemberConfig = t.type({
  id: t.string,
  name: t.string,
  isAdmin: t["boolean"],
  title: nullable(t.string),
  company: nullable(t.string),
  level: nullable(t.type({
    name: t.string
  })),
  avatarUrl: nullable(t.string)
});
export var MemberQuery = t.type({
  member: MemberConfig,
  currentUser: t.type({
    id: t.string,
    isAdmin: t["boolean"]
  })
});
export var MemberQueryVariables = t.type({
  memberId: t.string
});